import * as React from 'react';

import { usePropertyListing } from 'src/common/stores/contexts';

import { Theme } from 'constants/theme';

import { classNames } from 'uitk-react-utils';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';

export const Messaging: React.FunctionComponent = () => {
  const { offerSummary } = usePropertyListing();

  if (!offerSummary || !offerSummary.messages || offerSummary.messages.length === 0) {
    return null;
  }

  const messagesToDisplay = offerSummary.messages.map(offerMessage => {
    const { mark, message, theme, type } = offerMessage;

    const primaryTheme = theme && Theme[theme];

    const classes = classNames('uitk-cell pwa-theme--grey-700', {
      [`${primaryTheme}`]: primaryTheme,
    });

    return (
      <div key={`listing-message-${type}`} className={classes}>
        {mark?.url && <UitkMark url={mark.url.value} size={UitkMarkSize.SMALL} className="all-r-margin-one all-cell-align-middle" />}
        {mark?.id && !mark?.url && <UitkMark name={mark.id} size={UitkMarkSize.SMALL} className="all-r-margin-one all-cell-align-middle" />}
        {message || ''}
      </div>
    );
  });

  return messagesToDisplay.length ? (
    <div className="listing__messaging uitk-grid uitk-type-300" data-stid="content-hotel-primary-messaging">
      {messagesToDisplay}
    </div>
  ) : null;
};

Messaging.displayName = 'Messaging';
